var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FunnelWedding',_vm._b({attrs:{"antiForgeryToken":_vm.antiForgeryToken,"dataSource":_vm.dataSource},scopedSlots:_vm._u([{key:"collectivity-picker",fn:function(){return [_c('ScPlaceholder',{attrs:{"name":"jss-content","rendering":_vm.rendering}})]},proxy:true}])},'FunnelWedding',_vm.fields,false))
}
var staticRenderFns = []

export { render, staticRenderFns }